import React from 'react';
import { formatCurrency } from '../../../../../utils/format';
import { MODO_IMPRESSAO } from '~/constants';

const TotalizersSection = ({ documento, modoImpressao }) => {
  const itens = documento?.itens || [];
  const desconto = itens.reduce((total, item) => total + (item?.itemValorDesconto || 0), 0);
  const acrescimo = itens.reduce((total, item) => total + (item?.itemValorAcrescimo || 0), 0);
  const frete = itens.reduce((total, item) => total + (item?.itemValorFrete || 0), 0);
  const seguro = itens.reduce((total, item) => total + (item?.itemValorSeguro || 0), 0);
  const despesa = itens.reduce((total, item) => total + (item?.itemValorDespesa || 0), 0);
  const valorTotal = documento?.valorTotal || 0;
  const totalizadores = [
    { label: 'Subtotal:', value: valorTotal + desconto - acrescimo - frete },
    { label: 'Desconto:', value: desconto },
    { label: 'Acréscimo:', value: acrescimo },
    { label: 'Frete:', value: frete },
    { label: 'Seguro:', value: seguro },
    { label: 'Despesa:', value: despesa },
    { label: 'Total:', value: valorTotal },
  ];

  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;
  const ultimo = impressaoA4 ? null : totalizadores.at(-1);
  const restante = impressaoA4 ? totalizadores : totalizadores.slice(0, -1);
  const tamanhoColuna = impressaoA4 ? restante.length : Math.ceil(restante.length / 3);
  const colunas = Array.from({ length: impressaoA4 ? 1 : 3 }, (_, index) =>
    restante.slice(
      index * tamanhoColuna,
      (index + 1) * tamanhoColuna
    )
  );

  return (
    <div
      className='no-break scrollable'
      style={{
        justifyContent: 'space-evenly',
        padding: 'var(--spacing-size)',
        fontSize: 'var(--regular-text-size)',
        display: 'grid',
        gridTemplateColumns: impressaoA4 ? 'repeat(1, auto)' : 'repeat(3, auto)',
        rowGap: 'var(--vertical-item-grid-spacing)',
        columnGap: 'var(--spacing-size)',
        overflowX: 'auto'
      }}
    >
      <div style={{ gridColumn: '1 / -1', fontWeight: '700', fontSize: 'var(--section-title-text-size)', paddingBottom: 'var(--half-spacing-size)', textAlign: 'center' }}>
        TOTALIZADORES
      </div>

      {colunas.map((coluna, colIdx) => (
        <div
          key={colIdx}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
            width: '100%',
          }}
        >
          {coluna.map(({ label, value }, idx) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 'var(--horizontal-item-grid-spacing)',
              }}
            >
              <span style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap' }}>{label}</span>
              <span style={{ verticalAlign: 'top', textAlign: 'right', whiteSpace: 'nowrap', fontWeight: '700' }}>{formatCurrency(value)}</span>
            </div>
          ))}
        </div>
      ))}
      {ultimo && (
        <div
          style={{
            gridColumn: '1 / -1',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'baseline',
            gap: 'var(--horizontal-item-grid-spacing)',
            marginTop: 'var(--half-spacing-size)',
          }}
        >
          <span style={{ fontSize: 'var(--regular-text-size)', verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap' }}>{ultimo.label}</span>
          <span style={{ fontSize: 'var(--section-title-text-size)', verticalAlign: 'top', textAlign: 'right', whiteSpace: 'nowrap', fontWeight: '700' }}>{formatCurrency(ultimo.value)}</span>
        </div>
      )}
    </div>
  );
};

export default TotalizersSection;
